var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCutomerIconPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9985 14.0627C17.2422 14.0627 19.061 12.2439 19.061 10.0002C19.061 7.75659 17.2422 5.93774 14.9985 5.93774C12.7549 5.93774 10.936 7.75659 10.936 10.0002C10.936 12.2439 12.7549 14.0627 14.9985 14.0627Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56025 24.0623H21.4415C22.8689 24.0623 23.9684 22.8349 23.3019 21.5728C22.3213 19.7161 20.0859 17.4998 15.0009 17.4998C9.91589 17.4998 7.68047 19.7161 6.69993 21.5728C6.03334 22.8349 7.13285 24.0623 8.56025 24.0623Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutomerIconPlaceholder);
export default __webpack_public_path__ + "static/media/cutomerIconPlaceholder.09506b44.svg";
export { ForwardRef as ReactComponent };